module.exports = __webpack_public_path__ + "static/media/faico-connect.8dab1d5b.png";